export default __webpack_public_path__ + "static/media/gis-it.9bbff6a8.svg";